/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * A lighter version of the prospect's data, used for listing multiple prospects.
 */
export interface ProspectLight { 
    /**
     * A unique GUID for a prospect.
     */
    id: string;
    /**
     * BusinessName is an exclusive unique key across all prospects.
     */
    businessName: string;
    /**
     * Enum value of the application status.
     */
    readonly status?: ProspectLight.StatusEnum;
    /**
     * Enum value of schemaType associated with this prospectData
     */
    schemaType?: ProspectLight.SchemaTypeEnum;
    /**
     * True when deleted, ReadOnly.
     */
    readonly isDeleted?: boolean;
    /**
     * DateTime when created.
     */
    createdDate?: Date;
    /**
     * DateTime when updated.
     */
    updatedDate?: Date;
    /**
     * Coordinator who invited this prospect application.
     */
    coordinatorUserId?: string;
}
export namespace ProspectLight {
    export type StatusEnum = 'Invited' | 'Registered' | 'Submitted' | 'Migrated';
    export const StatusEnum = {
        Invited: 'Invited' as StatusEnum,
        Registered: 'Registered' as StatusEnum,
        Submitted: 'Submitted' as StatusEnum,
        Migrated: 'Migrated' as StatusEnum
    };
    export type SchemaTypeEnum = 'ArProspect' | 'DocumentCenter' | 'ScfBuyerProspect';
    export const SchemaTypeEnum = {
        ArProspect: 'ArProspect' as SchemaTypeEnum,
        DocumentCenter: 'DocumentCenter' as SchemaTypeEnum,
        ScfBuyerProspect: 'ScfBuyerProspect' as SchemaTypeEnum
    };
}